"use strict";
/**
 * Reference:
 * https://github.com/greatmindsorg/dp-account-management-auth-api/blob/develop/packages/dp-account-management-auth-api/src/auth/interfaces/user-profile.interface.ts
 * https://github.com/greatmindsorg/dp-account-management-auth-api/blob/develop/packages/dp-account-management-auth-api/src/impersonate/impersonate-response.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
